function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classnames from 'classnames';
import { Chip } from "../..";
export var MultiValue = function MultiValue(_ref) {
  var isFocused = _ref.isFocused,
      selectProps = _ref.selectProps,
      removeProps = _ref.removeProps,
      children = _ref.children,
      data = _ref.data;
  return /*#__PURE__*/React.createElement(Chip, {
    className: classnames(selectProps.classes.chip, _defineProperty({}, selectProps.classes.chipFocused, isFocused)),
    size: "small",
    clearable: !data.isFixed,
    onClear: removeProps.onClick
  }, children);
};